<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">7</h2>
<p class="vers"><span>Mein Lied</span> hat seines
Schmuckes sich<br class="calibre1"/>
entäußert, es ist nicht stolz auf Kleid<br class="calibre1"/>
und Zier. Der Schmuck könnt unsre<br class="calibre1"/>
Einigkeit zerstören, er würde zwischen<br class="calibre1"/>
dich und mich sich stellen; dein Flüstern<br class="calibre1"/>
könnt ertrinken in dem Klingklang.</p>
<p class="vers">Mein Dichterhochmut stirbt in Scham<br class="calibre1"/>
vor deinem Anblick, o Meisterdichter,<br class="calibre1"/>
ich saß dir zu Füßen. Laß mich mein<br class="calibre1"/>
Leben grad und einfach machen, gleich<br class="calibre1"/>
einer Flöte, die du füllst mit Tönen. <a id="page10" title="wedi/cal"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?fe7605bc